export const fetchUrl = async (url: string, extraHeaders = {}): Promise<string> => {
  const response = await fetch(url, { headers: { 'X-Alchemy-Request': 'true', ...extraHeaders } });
  const data = await response.text();
  return data as string;
};
